import getFormFile from './getFormFile'

export const getFormFileService = getFormFile

